import React from 'react';
import { useCheckSession, useSession } from 'components/Session';
import { toAuth } from 'constants/routes';
import { Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, layout: Layout, authUser, ...rest }) => {
  const hasSession = useCheckSession();
  const { activeProductUIDs, completedProductUIDs, brand } = useSession();
  const { isAdmin } = brand;

  if (
    !hasSession ||
    (!isAdmin && activeProductUIDs.length === 0 && completedProductUIDs.length === 0)
  ) {
    toAuth();
    return;
  }

  const renderComponent = props => {
    if (Layout) {
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }

    return <Component {...props} />;
  };

  return <Route {...rest} render={renderComponent} />;
};

export default PrivateRoute;
